import { fromJS } from 'immutable';

import { createAsyncAction } from '../utils';
import createWidgetActions from './create-widget-actions';

const initialState = fromJS({
    loading: false,
    error: null,
    summaries: [],
    data: null,
    dataDisplayIndex: 0,
    graphType: 'Line',
    environmentType: null,
    timePeriod: null,
    excludedLegendItems: [],
    timePeriodInfo: {
        start: null,
        end: null
    }
});

export const SUMMARY_SELECTED = 'LEAD_TIME_SUMMARY_SELECTED';
export const LEGEND_ITEM_TOGGLED = 'LEAD_TIME_LEGEND_ITEM_TOGGLED';

export const loadData = createAsyncAction('GET_LEAD_TIME');

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SUMMARY_SELECTED:
            return state.update('dataDisplayIndex', () => action.payload);
        case loadData.REQUEST:
            return state.update('loading', () => true).update('error', () => null)
            .update('environmentType', () => fromJS(action.payload.environmentType))
            .update('timePeriod', () => fromJS(action.payload.timePeriod));
        case loadData.SUCCESS:
            let newState = state
                .update('loading', () => false)
                .update('timePeriod', () => fromJS(action.payload.timePeriod))
                .update('graphType', () => fromJS(action.payload.graphType))
                .update('timePeriodInfo', () => fromJS(action.payload.timePeriodInfo));
            if (action.metadata.summary) {
                newState = newState.update('summaries', () => fromJS(action.payload.summaries));
            }
            if (action.metadata.graph) {
                newState = newState.update('data', () => fromJS(action.payload.data));
            }
            if (action.metadata.setEnvironmentType) {                
                newState = newState.update('environmentType', () => fromJS(action.payload.environmentType))
            }
            return newState;
        case loadData.FAIL:
            return state.update('loading', () => false).update('error', () => action.payload);
        case LEGEND_ITEM_TOGGLED:
            return state.update('excludedLegendItems', excludedLegendItems => {
                if (excludedLegendItems.indexOf(action.payload) === -1) {
                    return [ ...excludedLegendItems, action.payload];
                } else {
                    return excludedLegendItems.filter(eli => eli !== action.payload);
                }
            });
        default:
            return state;
    }
}

export function leadTimeActions($http, $q, api) {
    'ngInject';
    return createWidgetActions($http, $q, api, 'leadtime', {
        loadData,
        SUMMARY_SELECTED,
        LEGEND_ITEM_TOGGLED
    });
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/lead-time.js